import { Component, OnInit } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs/';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { OrganizationDetailsService } from '../../organization-details.service';
import { RxComponent } from 'app/core/components/common/rx.component';
@Component({
	selector: 'itpx-add-domain',
	templateUrl: './add-domain.component.html',
	styleUrls: ['./add-domain.component.css']
})
export class AddDomainComponent extends RxComponent implements OnInit {

	private domainId: string;
	domainForm: FormGroup;

	constructor(
		private modalService: SmartModalService,
		private fb: FormBuilder,
		private service: OrganizationDetailsService
	) { 
		super();
	}

	ngOnInit() {
		this.domainForm = this.fb.group({
			name: ['', Validators.required],
			isDefault: ['', Validators.required]
		})
		this.service.getDomainDetails()
			.bindToLifecycle(this)
			.subscribe(
				body => {
					let details = body.data;
					this.domainId = details.id
				}
			)
	}

	private onCancel() {
		this.modalService.close();
	}

	private onSave() {
		let details = this.domainForm.getRawValue();

		this.service.addAlternativeDomain(details, this.domainId)
			.subscribe(
				data => {
					this.modalService.sendResult('success');
				}
			)
	}

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/add-domain/add-domain.component.ts